import { Contract } from '../types/contract';
import { parseMoneyValue } from './currencyUtils';
import { splitCharacterNames } from './textUtils';

export interface PersonagemEventMatch {
  contractId: string;
  contratante: string;
  dataFesta: string;
  valorPersonagem: number;
  valorTotalContrato: number;
}

export interface PersonagemStats {
  totalEventos: number;
  receitaTotal: number;
  receitaMedia: number;
  eventos: PersonagemEventMatch[];
}

/**
 * Cruza o nome de um personagem cadastrado com a lista de contratos, usando
 * o texto livre em `personagensList`. Quando o contrato também informa o
 * valor do pacote de personagens, estima a fatia de receita atribuída a
 * esse personagem dividindo o pacote pela quantidade de personagens
 * listados naquele evento.
 */
export const getPersonagemStats = (nomePersonagem: string, contracts: Contract[]): PersonagemStats => {
  const target = nomePersonagem.trim().toLowerCase();
  const eventos: PersonagemEventMatch[] = [];

  contracts.forEach((contract) => {
    const nomes = splitCharacterNames(contract.personagensList);
    if (nomes.length === 0) return;

    const usado = nomes.some((nome) => nome.toLowerCase() === target);
    if (!usado) return;

    const precoPacote = parseMoneyValue(contract.personagensPrice);
    const valorPersonagem = !isNaN(precoPacote) && precoPacote > 0 ? precoPacote / nomes.length : 0;
    const valorTotalContrato = parseMoneyValue(contract.valor);

    eventos.push({
      contractId: contract.id || '',
      contratante: contract.contratante || 'Não informado',
      dataFesta: contract.dataFesta || '',
      valorPersonagem,
      valorTotalContrato: isNaN(valorTotalContrato) ? 0 : valorTotalContrato
    });
  });

  eventos.sort((a, b) => new Date(b.dataFesta || 0).getTime() - new Date(a.dataFesta || 0).getTime());

  const receitaTotal = eventos.reduce((sum, e) => sum + e.valorPersonagem, 0);

  return {
    totalEventos: eventos.length,
    receitaTotal,
    receitaMedia: eventos.length ? receitaTotal / eventos.length : 0,
    eventos
  };
};
